import { GET_TOKEN } from '../../actionTypes';
import { debugAction } from '../../utils';

export const token = {
  data: ''
};

export function tokenReducer(state = token, action) {
  debugAction(action);
  switch (action.type) {
    case GET_TOKEN:
      return { data: action.payload };
    default:
      return { ...state };
  }
}
